export default "__VITE_ASSET__b075b782__"